export function debounce( func, wait = 300 ) {
	let timeout;
	return function ( ...args ) {
		clearTimeout( timeout );
		timeout = setTimeout( () => func.apply( this, args ), wait );
	};
}

export function capitalizeFirstLetter( string ) {
	return string.charAt( 0 ).toUpperCase() + string.slice( 1 );
}

export function apiRequest( url ) {
	try {
		return fetch( url ).then( ( response ) => {
			if ( ! response.ok ) {
				return {};
			}
			return response.json();
		} );
	} catch ( error ) {
		return Promise.resolve( {} );
	}
}

export async function acfReady() {
	if (
		typeof window.acf !== 'undefined' &&
		typeof window.acf.addAction === 'function'
	) {
		await new Promise( ( resolve ) =>
			window.acf.addAction( 'ready', resolve )
		);
	}
}
